import styled from 'styled-components'
import { COLORS } from '@assets/styles/colors'

export const List = styled.ul`
	display: flex;
	column-gap: 19px;
	list-style: none;
	padding: 0;
	margin: 0;
`

export const ListItem = styled.li`
	list-style: none;
	display: flex;
	align-items: center;
	text-align: center;
	padding: 3px 8px;
	color: white;
	background-color: ${COLORS.DECORATIVE_LIGHT_BLUE};
	border-radius: 20px;
`
